import { render, staticRenderFns } from "./SimilarCarousel.vue?vue&type=template&id=3a43f546&scoped=true&"
import script from "./SimilarCarousel.vue?vue&type=script&lang=js&"
export * from "./SimilarCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SimilarCarousel.vue?vue&type=style&index=0&id=3a43f546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43f546",
  null
  
)

export default component.exports